<!--
/**
 * @fileoverview Group component
 * @license MIT
 * @author Gabriel Jimenez <gjimenez@nextdigital.es>
 * @package GanttElastic
 */
-->
<template>
  <g>
    <g
      v-for="subtask in subtaskList"
      :key="subtask.id"
    >
      <component
        :is="subtask.type"
        :task="subtask"
      />

      <div>/////</div>
      <week-end
        v-if="checkRange(subtask)"
        :task="subtask"
        :days="searchHolliday(subtask)"
      />
    </g>
  </g>
</template>

<script>
import ChartText from '../Text.vue';
import ProgressBar from '../ProgressBar.vue';
import Expander from '../../Expander.vue';
import taskMixin from './Task.mixin.js';
import Task from 'gantt-elastic/src/components/Chart/Row/Task';
import Milestone from 'gantt-elastic/src/components/Chart/Row/Milestone';
import Project from 'gantt-elastic/src/components/Chart/Row/Project';
import dayjs from 'dayjs'
import WeekEnd from './Weekend.vue';

export default {
  name: 'Group',
  components: {
    Task,
    Milestone,
    Project,
    WeekEnd
  },
  inject: ['root'],
  mixins: [taskMixin],
  props: ['task'],
  data() {
    return {};
  },
  computed: {
    subtaskList() {
      return this.task.tasks;
    },

    workingDays() {
      return this.root.state.options.times.steps.filter(step => {
        return this.root.state.options.calendar.workingDays.indexOf(dayjs(step.time).day()) === -1;
      });
    },
  },

  methods: {
      checkRange (task) {
      return this.workingDays.some(el => {
        return (
          (dayjs(el.time).isAfter(task.startTime) || dayjs(el.time).isSame(task.startTime)) &&
          (dayjs(el.time).isBefore(task.endTime) || dayjs(el.time).isSame(task.endTime))
        )
      })
    },

    searchHolliday (task) {
      let element = []
      for (let index = 0; index < this.workingDays.length; index++) {
        const el = this.workingDays[index]
        if (
          (dayjs(el.time).isAfter(task.startTime) || dayjs(el.time).isSame(task.startTime)) &&
          (dayjs(el.time).isBefore(task.endTime) || dayjs(el.time).isSame(task.endTime))
        ) {
          element.push(el)
        }
      }

      return element
    },
  }
};
</script>
